import { useEffect, useState } from "react";

const useConnexionState = () => {

    var conn = navigator && ((navigator as any).connection || (navigator as any).mozConnection || (navigator as any).webkitConnection);
    const [isOnline, setIsOnline] = useState<boolean>(navigator.onLine)

    useEffect(() => {
        var handleConnexionChange = () => {
            setIsOnline(navigator.onLine)
        }

        window.addEventListener("online", handleConnexionChange, { passive: true });
        window.addEventListener("offline", handleConnexionChange, { passive: true });
        if (conn) {
            conn.addEventListener("change", handleConnexionChange, { passive: true });
        }

        return () => {
            window.removeEventListener("online", handleConnexionChange);
            window.removeEventListener("offline", handleConnexionChange);
            if (conn) {
                conn.removeEventListener("change", handleConnexionChange);
            }
        };
    }, []);

    return {
        isOnline
    };
};

export default useConnexionState;